import { styled } from '@mui/material'

export const MarkerContainer = styled('div')(({ theme }) => ({
  margin: '-25px 0 0 -25px',
  border: `5px solid ${theme.palette.primary.main}`,
  borderRadius: '50%',
  width: 45,
  height: 45,
  cursor: 'pointer',
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1,
  '& >div': {
    borderRadius: '50%',
    border: `2px solid ${theme.palette.primary.main}`,
    width: 30,
    height: 30,
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))
